import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import { Tab, Tabs } from 'components/tabs';
import { OrderLocatorTab } from 'state/launchdarkly/variations';

import { TabsBarWrapper } from './tabs.styled';
import { ITabsBarProps } from './types';
import { a11yPropsTabs } from './utils';

const TAB_MESSAGE_ID_MAP = {
  [OrderLocatorTab.DELIVERY]: 'delivery',
  [OrderLocatorTab.FAVORITE]: 'favorite',
  [OrderLocatorTab.NEARBY]: 'nearby',
  [OrderLocatorTab.RECENT]: 'recent',
};

const TAB_TEST_ID_MAP = {
  [OrderLocatorTab.DELIVERY]: 'delivery-tab',
  [OrderLocatorTab.FAVORITE]: 'favorite-tab',
  [OrderLocatorTab.NEARBY]: 'nearby-tab',
  [OrderLocatorTab.RECENT]: 'recent-tab',
};

/**
 *
 * TabsBar contains the tab buttons for each enabled tab
 *
 */
const TabsBar: FC<ITabsBarProps> = ({
  locatorTabs,
  locatorTabIds,
  currentTabIndex,
  handleTabChangeEvent,
  hideDeliveryTab = false,
}) => {
  const { formatMessage } = useIntl();
  const orderedTabs = locatorTabs.map(tab => {
    switch (tab) {
      case OrderLocatorTab.DELIVERY:
        return hideDeliveryTab ? null : (
          <Tab
            key={tab}
            label={formatMessage({ id: TAB_MESSAGE_ID_MAP[tab] })}
            {...a11yPropsTabs(locatorTabIds[tab])}
            value={locatorTabIds[tab]}
            data-testid={TAB_TEST_ID_MAP[tab]}
          />
        );
      case OrderLocatorTab.FAVORITE:
      case OrderLocatorTab.NEARBY:
      case OrderLocatorTab.RECENT:
        return (
          <Tab
            key={tab}
            label={formatMessage({ id: TAB_MESSAGE_ID_MAP[tab] })}
            {...a11yPropsTabs(locatorTabIds[tab])}
            value={locatorTabIds[tab]}
            data-testid={TAB_TEST_ID_MAP[tab]}
          />
        );
      default:
        return null;
    }
  });

  return (
    <TabsBarWrapper data-testid={'store-locator-tabs-bar'}>
      <Tabs tabWidth="fill" selectedIndex={currentTabIndex} onChange={handleTabChangeEvent}>
        {orderedTabs}
      </Tabs>
    </TabsBarWrapper>
  );
};

export default TabsBar;
